// src/hooks/useSyncLanguage.js
import { useEffect } from "react";

export default function useSyncLanguage(setCurrentLang) {
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "language") {
        const newLang = e.newValue || "en";
        setCurrentLang(newLang);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // Same-tab changes detection
    let prevLang = sessionStorage.getItem("language");
    const interval = setInterval(() => {
      const lang = sessionStorage.getItem("language");
      if (lang !== prevLang) {
        prevLang = lang;
        setCurrentLang(lang || "en");
      }
    }, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [setCurrentLang]);
}
